export default {
  pageLayout: "full", // we have'full','right' & 'left' layout
  button: {
    primaryText: "", // start, next, submit
    secondaryText: "", // back button text
    alignment: "left",
  },
  backgroundImage: {},
};
